import { useQuery } from '@tanstack/react-query';
import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';
import { useAuthStore } from '@/store/authStore';
import type { CheckStatusResponse } from '../types/auth.types';

/**
 * Re-reads the signed-in profile (GET /authentication/check-status) into the
 * auth store, so a tier, name or photo changed since sign-in shows up.
 * Read the profile from useAuthStore; this hook only keeps it fresh.
 */
export const useSessionProfile = () => {
  const isLogin = useAuthStore((state) => state.isLogin);
  const userId = useAuthStore((state) => state.user_id);
  return useQuery({
    queryKey: ['session-profile', userId],
    queryFn: async () => {
      const profile = await request.get<CheckStatusResponse>(`${URLS.BACK_DSH}${APIS.checkStatus}`);
      useAuthStore.getState().setAuth(profile);
      return profile;
    },
    enabled: isLogin,
  });
};
